/**
 * 「处理状态」的六个合法取值，一字不差照《流程规格-v2-人工驱动-20260826》§一。
 *
 * v2（人工驱动）把 AI 从「驱动流程」改成「提供建议，人工执行」，
 * v1 的十一态里那七个 AI 中间态与「人工·已回访」**已全部删除**：
 *   AI·预受理 / AI·已受理 / AI·告知书处理中 / AI·已生成告知书 /
 *   AI·判定中 / AI·判定完成 / 人工·已回访
 *
 * 与 v1 的一处口径反转：**「不受理」在 v2 里是独立状态**，
 * 不再是「受理判定」字段的值 ＋「人工·已办结」两段拼出来的。
 * 「受理判定」字段仍然保留，但由人工写入，AI 的建议另存。
 *
 * 数组顺序即流转顺序，与乐享「处理状态」字段的选项顺序一致。
 */
export const CASE_STATES = [
  '待受理',
  '已联系投诉人',
  '已受理',
  '已联系被投诉人',
  '已办结',
  '不受理',
] as const;

export type CaseState = (typeof CASE_STATES)[number];

const STATE_SET: ReadonlySet<string> = new Set<string>(CASE_STATES);

/** 是否为六态之一。 */
export function isCaseState(s: string): s is CaseState {
  return STATE_SET.has(s);
}

/** 「受理判定」字段的取值（不是状态）。 */
export const ACCEPT_VERDICTS = ['受理', '不受理'] as const;
export type AcceptVerdict = (typeof ACCEPT_VERDICTS)[number];
